module.exports = __webpack_public_path__ + "img/setting_plain.e5178273.svg";